import { useState } from "react";

import productApi from "../../api/productApi";
import productFamilyApi from "../../api/productFamilyApi";
import productTypeApi from "../../api/productTypeApi";
import productCategoryApi from "../../api/productCategoryApi";
import brandApi from "../../api/brandApi";
import useMount from "../../hooks/useMount";
import AlertModal from "../Commons/AlertModal";
import ActionButton from "../Commons/ActionButton";
import AdminProductModal from "./AdminProductModal";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";

import { getLabel, getLanguage } from "../../tools/Dictionary";


import { MdAdd } from "react-icons/md";


const AdminProductCont = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ParentLoading = props.ParentLoading;
  const setParentLoading = props.setParentLoading;


  //State
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);
  const [currentProduct, setCurrentProduct] = useState([]);
  const [productFamily, setProductFamily] = useState([]);
  const [productType, setProductType] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [brand, setBrand] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_Product", "code"),
      property: "code",
      style: { width: "20%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "label"),
      property: "label",
      style: { width: "20%", minWidth: "100px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "brand"),
      property: "brand.code",
      style: { width: "10%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "productCategory"),
      property: "productCategory.code",
      style: { width: "10%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "productType"),
      property: "productType.code",
      style: { width: "10%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "productFamily"),
      property: "productFamily.code",
      style: { width: "10%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "virtualAssistant"),
      property: "virtualAssistant",
      style: { width: "10%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Product", "isActive"),
      property: "isActive",
      style: { width: "10%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
      filterOperator: "like",
      filterValue: ""
    }
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [modal, setModal] = useState({
    id: 0,
    display: false
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  useMount(() =>
  {
    loadData();
  }, []);

  const loadData = async (_showLoading = true) =>
  {

    try
    {

      if (_showLoading)
      {
        setParentLoading(true);
        setLoading(true);
      }

      let [productData, productFamilyData, producTypeData, productCategoryData, brandData] = await Promise.all([
        productApi.getProducts({ select: `_id,code,label,brand,productCategory,productType,productFamily,process,isActive,virtualAssistant`, translate: getLanguage().code, populate: "brand,productCategory,productType,productFamily,process" }),
        productFamilyApi.getProductFamilies({ filter: "isActive is true", select: `_id,code,label,hierarchy,isActive,order`, translate: getLanguage().code, sort: "code asc" }),
        productTypeApi.getProductTypes({ filter: "isActive is true", select: `_id,code,label,hierarchy,isActive,order`, translate: getLanguage().code, sort: "code asc" }),
        productCategoryApi.getProductCategories({ filter: "isActive is true", select: `_id,code,label,hierarchy,isActive,order`, translate: getLanguage().code, sort: "code asc" }),
        brandApi.getBrands({ filter: "isActive is true", select: `_id,code,label,isActive,order`, translate: getLanguage().code, sort: "code asc" })
      ]);

      if (productData.Success)
      {

        let loadedProduct = applyListFilterAndSort(productData.Data, column, sort);

        setProduct(loadedProduct);
        checkDataUpdateForPagination(loadedProduct, pagination);


      } else
        throw new Error(productData.Error.label);

      if (productFamilyData.Success)
        setProductFamily(productFamilyData.Data);
      else
        throw new Error(productFamilyData.Error.label);


      if (producTypeData.Success)
        setProductType(producTypeData.Data);
      else
        throw new Error(producTypeData.Error.label);

      if (productCategoryData.Success)
        setProductCategory(productCategoryData.Data);
      else
        throw new Error(productCategoryData.Error.label);

      if (brandData.Success)
        setBrand(brandData.Data);
      else
        throw new Error(brandData.Error.label);


      setParentLoading(false);
      setLoading(false);

    } catch (err)
    {

      setParentLoading(false);
      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentProduct(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(product, _sort);

    setProduct(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(product, _column);

    setProduct(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };



  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(product, tempPagination);

  };


  const onClickItem = (_item) =>
  {

    setModal({
      id: _item._id,
      display: true,
      duplicate: undefined
    });

  };

  const onClickNew = () =>
  {

    setModal({
      id: 0,
      display: true,
      duplicate: undefined
    });

  };

  const onDuplicate = async(_data) => {

    setModal({
      id: 0,
      display: true,
      duplicate: _data
    });

  };

  // const onSaveDuplicateFile = async(_id, _selected) => {
  
  //   try{


  //   }catch(err){

  //     setAlert({
  //       Title: getLabel("App", "Error"),
  //       Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
  //       Confirm: getLabel("App", "Ok"),
  //       onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
  //       Display: true
  //     });

  //   }

   



  
  // }


  let currentLoading = loading || ParentLoading;

  return (
    <div className="page_body_cont">
      {modal.display &&
        <AdminProductModal
          IsDesktop={IsDesktop}
          Id={modal.id}
          ProductFamily={productFamily}
          ProductType={productType}
          ProductCategory={productCategory}
          Brand={brand}
          Access={Access}
          OnCloseModal={() => setModal({ id: 0, display: false })}
          LoadData={() => loadData(false)}
          OnDuplicate={onDuplicate}
          Duplicate={modal.duplicate}
        />
      }
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="page_action_cont" style={{ width: "90%", maxWidth: "1200px" }}>
        <div className="page_action_section" style={{ width: "30%" }}>
          <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("App", "New")}
            Icon={MdAdd}
            Disabled={currentLoading}
            OnClick={onClickNew}
          />
        </div>
        <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
          <Pagination
            IsDesktop={IsDesktop}
            data={pagination}
            onChangePage={onChangePage}
            count={product.filter(p => !p.bFiltered).length}
          />
        </div>
        <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
          <ListFilter
            IsDesktop={IsDesktop}
            column={column}
            Data={product}
            OnApplyFilter={onApplyFilter}
          />
        </div>
      </div>

      <ListComponent
        IsDesktop={IsDesktop}
        Column={column}
        Data={currentProduct}
        Sort={sort}
        ListStyle={{ width: "90%", maxWidth: "1200px" }}
        Loading={loading}
        Debug={false}
        OnClickSort={onClickSort}
        OnClickItem={onClickItem}
      />

    </div>
  );

}


export default AdminProductCont;